module.exports = __webpack_public_path__ + "img/cooperation04.ed92e122.png";